import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: {
          base: '#77b82a',
          darken1: colors.blueGrey.darken1,
        },
        secondary: {
          base: colors.blueGrey.lighten1,
          lighten1: '#f4f4f4',
        },
        accent: '#f3f6fb',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: {
          base: '#78b800',
          darken1: colors.blueGrey.darken3,
        },
        secondary: {
          base: colors.blueGrey.darken3,
          lighten1: '#161616',
        },
        accent: '#f3f6fb',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
})
